import { useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import LoginImage from '@/assets/images/LoginImage.svg';

import { authService } from '@/services/auth';
import { useToast } from '@/hooks/use-toast';

import { Button } from '@/components/ui/button';
import { AuthBackground } from '@/components/AuthBackground';

interface LocationState {
  email?: string;
}

export default function ForgotPasswordSent() {
  const location = useLocation();
  const { toast } = useToast();
  const [isResending, setIsResending] = useState(false);
  const email = (location.state as LocationState | null)?.email;

  if (!email) {
    return <Navigate to="/forgot-password" replace />;
  }

  const handleResend = async () => {
    setIsResending(true);
    try {
      await authService.forgotPassword({ email });
    } catch {
      toast({
        variant: 'error',
        title: 'Erro ao reenviar link',
        description: 'Tente novamente mais tarde.',
      });
    } finally {
      setIsResending(false);
    }
    toast({
      variant: 'success',
      title: 'Link reenviado',
      description: 'Verifique sua caixa de entrada.',
    });
    setIsResending(false);
  };

  return (
    <div className="min-h-screen bg-highlight flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8 relative">
      <AuthBackground />
      <div className="flex flex-col items-center mb-6 relative z-10">
        <img src={LoginImage} alt="Culture Monitor" className="w-44" />
      </div>
      <div className="relative z-10">
        <div className="bg-white rounded-2xl border border-[#E5E5E5] p-8 w-full sm:w-[28rem] flex flex-col gap-6">
          <div className="text-center">
            <h1 className="text-xl font-sans font-semibold text-gray-900 mb-4">
              Verifique seu e-mail
            </h1>
            <p className="text-sm font-sans font-normal text-[#737373] mb-2">
              Enviamos um link para redefinição de senha para{' '}
              <span className="font-medium text-gray-900">{email}</span>
            </p>
            <p className="text-sm font-sans font-normal text-[#737373]">
              Não encontrou o e-mail? Verifique a pasta de spam ou clique abaixo para reenviar o link.
            </p>
          </div>
          <Button
            type="button"
            variant="outline"
            disabled={isResending}
            onClick={handleResend}
            className="w-full border border-[#E5E5E5] bg-white text-gray-900 hover:bg-gray-50 disabled:opacity-50"
          >
            {isResending ? 'Reenviando...' : 'Reenviar link'}
          </Button>
        </div>
      </div>
    </div>
  );
}
